import FormSectionHeader from "../common/FormSectionHeader";
import { withStyles } from "@material-ui/core";
import styles from "./styles";
import { memo } from "react";
import RadioGroup from "./RadioGroup";

const Header = withStyles(styles)(FormSectionHeader);
const SelectShipperForm = ({
  classes,
  shipperList,
  selectedShipper,
  handleShipperSelection,
  isShipperSearched,
}) => {
  return (
    <div id="headerContainer" className={classes.headerContainer}>
      <Header label="Select Shipper" />
      <div
        id="radioContainer"
        className={`${classes.radioContainer} customScroll`}
      >
        <RadioGroup
          onChange={handleShipperSelection}
          options={shipperList}
          value={isShipperSearched ? "" : selectedShipper}
          disabled={isShipperSearched}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(memo(SelectShipperForm));
